import React, { useEffect } from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { useLocation } from "@reach/router"
import GetHeader from "../components/getHeader"
import "../styles/contact.css"

const Contact = (props) => {
  const location = useLocation()
  const wasRedirected = location.action === "PUSH" && !location.state.noChange ? true : null

  useEffect(() => {
    if (wasRedirected) {
      const darkness = document.getElementById("darkness")
      if (darkness) setTimeout(() => document.getElementById("darkness").remove(), 60)
    }
    document.getElementById("textWrapper").classList.remove("onAbove")
  }, [wasRedirected])

  if (props.pageContext.hebrew) {
    return (
      <Layout>
        <div id="contact" className={wasRedirected ? "rollingPage active" : "rollingPage"}>
          <SEO
            title="צור קשר"
            description='יש לכם שאלה, רעיון להגשים או עסק שתרצו לשדרג? שלחו הודעה לאיתי שיף והוא יעזור לכם להגשים את החלום שלכם ע"י בניית האתר המושלם שאתם בדיוק צריכים.'
            keywords={["צור קשר", "אימייל"]}
          />

          <GetHeader />

          <section className="wrapper notHomepage">
            <div id="stars"></div>
            <div id="stars3"></div>

            <div id="innerWrapperContent" className="hebrew">
              <h1>צור קשר</h1>
              <h2>איתי שיף</h2>
            </div>
          </section>

          <div id="textWrapper" className="hebrew onAbove">
            <h3>הרגישו חופשי ליצור איתי קשר !</h3>
            <p>אהיה כאן בשביל לענות לך, בין אם יש לך רעיון שאתה מעוניין להגשים, אם אתה רוצה להעסיק אותי או גם אם סתם בא לך לדבר.</p>

            <form name="צור_קשר" id="contactForm" method="POST" data-netlify="true" data-netlify-honeypot="bot-field">
              <input type="hidden" name="form-name" value="צור_קשר" />
              <label htmlFor="fullName">שם מלא</label>
              <input type="text" name="full-name" id="fullName" placeholder="איתי שיף" required />
              <label htmlFor="emailAddress">כתובת אימייל</label>
              <input type="email" name="email-address" id="emailAddress" placeholder="itaysbusiness@gmail.com" required />
              <label htmlFor="subject">נושא</label>
              <input type="text" name="subject" id="subject" placeholder="מעוניין לשדרג את העסק שלי" required />
              <label htmlFor="messageBox">הודעה</label>
              <textarea type="text" name="message" id="messageBox" placeholder="תוכן ההודעה" required />
              <button>שלח</button>
            </form>
          </div>
        </div>

        {wasRedirected && <div id="darkness"></div>}
      </Layout>
    )
  }

  // Else render it in English
  return (
    <Layout>
      <div id="contact" className={wasRedirected ? "rollingPage active" : "rollingPage"}>
        <SEO
          title="Contact"
          description="You have any question, idea to fulfill or a business you'd like to upgrade? Contact Itay Shiff and he'll help you fulfill your dream by building the perfect website for your exact needs."
          keywords={["Contact", "Email Address"]}
        />

        <GetHeader />

        <section className="wrapper notHomepage">
          <div id="stars"></div>
          <div id="stars3"></div>

          <div id="innerWrapperContent">
            <h1>Contact Me</h1>
            <h2>Itay Shiff</h2>
          </div>
        </section>

        <div id="textWrapper" className="onAbove">
          <h3>Feel free to message me !</h3>
          <p>I'll be here to answer you if you have any idea you'd like to fulfill, if you want to hire me, or even if you just want to talk with me.</p>

          <form name="contact" id="contactForm" method="POST" data-netlify-honeypot="bot-field" data-netlify="true">
            <input type="hidden" name="form-name" value="contact" />
            <label htmlFor="fullName">Full Name</label>
            <input type="text" name="full-name" id="fullName" placeholder="Itay Shiff" required />
            <label htmlFor="emailAddress">Email Address</label>
            <input type="email" name="email-address" id="emailAddress" placeholder="itaysbusiness@gmail.com" required />
            <label htmlFor="subject">Subject</label>
            <input type="text" name="subject" id="subject" placeholder="I need a good website for my small business" required />
            <label htmlFor="messageBox">Message</label>
            <textarea type="text" name="message" id="messageBox" placeholder="Enter your message" required />
            <button>SEND</button>
          </form>
        </div>
      </div>

      {wasRedirected && <div id="darkness"></div>}
    </Layout>
  )
}

export default Contact
